import React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { ColumnModel } from "../../../models/common.model";
import { installments } from "../../../models/loan.model";

const columns: readonly ColumnModel[] = [
  { id: "installmentNo", label: " شماره قسط " },
  { id: "dueDate_Persian", label: " تاریخ قسط " },
  {
    id: "amount",
    label: "مبلغ قسط (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  { id: "paymentDate_Persian", label: "تاریخ پرداخت " },
  {
    id: "paidAmount",
    label: "مبلغ پرداخت شده (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value?.toLocaleString("fa");
    },
  },
  { id: "gateway", label: "درگاه پرداخت" },
  { id: "traceNumber", label: "شماره پیگیری" },
];
export default function Installments({ data }: { data?: installments[] }) {
  return (
    <>
      <Paper sx={{ width: "100%", overflow: "hidden" }}>
        <TableContainer
          className="tabsScroll"
          style={{
            maxHeight: "30%",
            overflowY: "auto",
            width: "100%",
            direction: "rtl",
            paddingRight: "0",
            paddingTop: "0",
          }}
        >
          <Table
            stickyHeader
            aria-label="sticky table"
            className=" directionRTL"
            style={{ borderCollapse: "collapse" }}
          >
            <TableHead style={{ position: "-webkit-sticky", top: "0px" }}>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    className="rowTHead colorTitle textFont14 fontWeight"
                    key={column.id}
                    align="right"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <div style={{ width: "100%", height: "10px" }}></div>
            <TableBody>
              {data?.map((row, rowIndex) => {
                return (
                  <TableRow
                    className={`${
                      rowIndex % 2 == 0
                        ? "rowTBodyE  borderRight borderLeft"
                        : "rowTBodyO  borderRight borderLeft"
                    }`}
                    hover
                    role="checkbox"
                    tabIndex={-1}
                    key={rowIndex}
                  >
                    {columns.map((column) => {
                      const value = row[column.id as keyof installments];
                      return (
                        <TableCell
                          className="textFont14"
                          key={column.id}
                          align="right"
                        >
                          {column.format && column.hasFormat
                            ? column.format(value?.toLocaleString())
                            : value?.toLocaleString()}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </>
  );
}
